import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import Breadcrumbs from './Breadcrumbs';

export default withRouter(class Header extends Component {
    render() {
      const { location } = this.props;

      if (location.pathname === '/') {
        return null;
      }

      return (
        <Fragment>
          <Container fluid>
            <Row>
              <Col xs>
                <Breadcrumbs/>
              </Col>
            </Row>
          </Container>
        </Fragment>
      );
    }
  }
);
